import Vue from 'vue'
import VueRouter from 'vue-router'
import Editor from '@/views/Editor'
import MyPages from '@/views/MyPages'
import MyPages2 from '@/views/MyPages2'
import SnsBlocks from '@/views/SnsBlocks'
import SnsBlock from '@/views/SnsBlock'
import Main from '@/views/Main'
import MainLayout from '@/components/layout/MainLayout'

import store from "../store";
Vue.use(VueRouter)
import axios from "axios";

const checkAuth = () => (from, to, next) => { // 세션 체크
    var url = '/api_home/session/status'
    axios
        .get(url)
        .then(data=>{ // 로그인 성공
            store.commit('login', data.data.sessionInfo.sessionChecked)
            store.commit('shopid', data.data.sessionInfo.mallId)
            next()
        }).catch(error=>{ // 로그인 에러
            if(error.response.status == 401){
                store.commit('login', error.response.data.sessionType)
            }
            next()
        })
}


const routes = [
    {
        path: '/',  name: 'home_main',  component: MainLayout, beforeEnter: checkAuth(),
        children: [
            {path: '/',  name: 'Main',  component: Main},
            {path: '/editor',  name: 'Editor',  component: Editor},
            // {path: '/pages',  name: 'MyPages',  component: MyPages},
            {path: '/pages',  name: 'MyPages2',  component: MyPages2},
            {path: '/sns-blocks',  name: 'SnsBlocks',  component: SnsBlocks},
        ]
    },
    {path: '/sns-block/:blockId',  component: SnsBlock},
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
